import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { isOnVacation } from '@/utils/vacation';

const STATUS_BADGES: Record<string, { label: string; cls: string }> = {
  verifying: { label: 'Verificando', cls: 'bg-info/80 text-white' },
  test: { label: 'Prueba final', cls: 'bg-brand-coral/90 text-void' },
  redemption_test: {
    label: 'En redención',
    cls: 'bg-brand-coral/90 text-void',
  },
  failed: { label: 'Prueba no superada', cls: 'bg-error/90 text-white' },
  banned: { label: 'Game over', cls: 'bg-error/90 text-white' },
  vacation: { label: 'De vacaciones', cls: 'bg-info/80 text-white' },
};

const BASE = 'rounded-full px-2 py-0.5 text-[9px] font-medium';

type Props = {
  status?: string | undefined;
  test_passed_at?: string | undefined;
  vacation_starts_at?: string | undefined;
  vacation_ends_at?: string | undefined;
};

const TERMINAL_OR_CRITICAL = new Set(['banned', 'failed', 'redemption_test']);

function pickKey(p: Props): string | null {
  if (p.status === 'banned' && !p.test_passed_at) return 'failed';
  if (p.status && TERMINAL_OR_CRITICAL.has(p.status)) return p.status;
  if (isOnVacation(p)) return 'vacation';
  return p.status ?? null;
}

export function StatusBadge(p: Props): ReactNode {
  const key = pickKey(p);
  const b = key ? STATUS_BADGES[key] : undefined;
  if (!b) return null;
  return <span className={cn(BASE, b.cls)}>{b.label}</span>;
}
